import mqtt from '@/services/aws-iot/mqtt'
import { userMessageParser } from '@/services/parser/userMessageParser'
import { GlobalVars } from '@/services/globals'
import { constantStrings, cookieConstant } from '@/services/constants'
import { clearTimersUponEndChat, showMessageSeparatorPill } from '@/services/utils'
import { getCookie } from '@/services/cookie'
import AppLog from '@/services/errors/app-logs'
import session from '../../services/session'

export default {
    renderBroadcastMessage({commit, dispatch, rootState}, data) {
        if(rootState.chats.length == 0) {
          new AppLog({
            name: 'Render Broadcast Message',
            message:`ConversationId inside the fn renderBroadcastMessage: ${data?.conversationId}, conversationId inside cookie: ${getCookie(cookieConstant.SESSION.CONVERSATION_ID)}`,
            logLevel: 'info',
            service: 'BroadcastChannel_Ac'
          })
          mqtt.createSubscription(data.conversationId)
        }
        const messageBody = userMessageParser(data)
        dispatch('updateQuickReplyOptions', []) 
        data.updateLastChatBlock
        ? commit('REPLACE_LAST_IMAGE_SKELETON', messageBody)
        : commit('UPDATE_CHATS', messageBody)
    },

    endChatAcrossTabs({dispatch, rootState}, data) {
      clearTimersUponEndChat()
      if (rootState.controlType === constantStrings.AGENT) {
        GlobalVars.$liveAgent.endChatWithLiveAgent()
      }
      dispatch('clearChatsWithAgentDesk')
      // Show Flag to user if chat has ended
      showMessageSeparatorPill({
        message: data.message,
        isEndChatSeparator: true
      })
      dispatch('handleClearConversationStatus', rootState.widgetConfig?.endChatClearConversation)

      const {footerStatus} = rootState.widgetConfig
      if(!footerStatus) {
        dispatch('handleInputFieldStatusOnEndChat')
      }
      dispatch('updateShowFormControls', false)
      dispatch('updateQuickReplyOptions', []) // Clear Quick Reply Options if any
      if(rootState.widgetConfig?.inactiveOverlay?.showButtons) {
        dispatch('updateOverlayStatus', false)
      }
      dispatch('overlayIdleChatTimeout')
      if (footerStatus && footerStatus === constantStrings.DISABLED) {
        dispatch('updateInputFieldDisableStatus', true)
      }
      if (footerStatus && footerStatus === constantStrings.HIDDEN) {
        dispatch('updateInputFieldHiddenStatus', true)
      }

      const clearConversation = rootState.widgetConfig?.endChatClearConversation
      if (clearConversation) {
        dispatch('clearChats')
        dispatch('updateClearConversationStatus', clearConversation)
      }
      if (data?.restartChat) {
        session.restartConversation()
      } else {
        mqtt.unsubscribe()
        session.endConversation()
      }
    },
    
    updateLastFormSubmission({commit}, form) {
        commit('UPDATE_FORM_STATUS', form)
    }
}
